var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { zIndex } from '../../styles';
export function ClientOnlyPortal(_a) {
    var children = _a.children, selector = _a.selector;
    var ref = useRef(null);
    var _b = useState(false), mounted = _b[0], setMounted = _b[1];
    useEffect(function () {
        ref.current = document.querySelector(selector);
        if (!ref.current) {
            throw Error("Selector: ".concat(selector, " not found in document"));
        }
        setMounted(true);
    }, [selector]);
    return mounted && ref.current ? createPortal(children, ref.current) : null;
}
export default function OverlayPortal(_a) {
    var children = _a.children, _b = _a.selector, selector = _b === void 0 ? '#modal-root' : _b, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c, _d = _a.color, color = _d === void 0 ? 'rgba(66, 77, 93, 0.1)' : _d;
    return (_jsx(ClientOnlyPortal, __assign({ selector: selector }, { children: _jsx(OverlayShade, __assign({ onClick: onClick, color: color }, { children: _jsx(ModalContainer, __assign({ onClick: function (e) {
                    e.stopPropagation();
                } }, { children: children })) })) })));
}
export var OverlayShade = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n  min-width: 100vw;\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: ", ";\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n  min-width: 100vw;\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: ", ";\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), zIndex('modal'), function (props) { return props.color; });
var ModalContainer = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  height: 100%;\n  width: 100%;\n"], ["\n  display: block;\n  height: 100%;\n  width: 100%;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map